/**
 * Card Color Swatches Component
 * Handles swatch click → smooth image crossfade, active state, and link update.
 */
(function () {
  var FADE_DURATION = 300;

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.card-swatch');
    if (!swatch) return;
    e.preventDefault();

    var card =
      swatch.closest('.br-prod-simple__item') ||
      swatch.closest('.card-wrapper');
    if (!card) return;

    var img =
      card.querySelector('.br-prod-simple__media img') ||
      card.querySelector('.card__media img');

    /* Store original image on first interaction */
    if (img && !img.dataset.originalSrc) {
      img.dataset.originalSrc = img.src;
      img.dataset.originalSrcset = img.srcset || '';
    }

    var imageUrl = swatch.dataset.variantImage;
    var newSrc = imageUrl || (img && img.dataset.originalSrc) || '';

    /* Smooth crossfade: fade out → swap → fade in */
    if (img && newSrc && newSrc !== img.src) {
      img.classList.add('card-swatch-fade');

      setTimeout(function () {
        img.src = newSrc;
        img.srcset = imageUrl ? '' : (img.dataset.originalSrcset || '');

        if (img.complete) {
          img.classList.remove('card-swatch-fade');
        } else {
          img.onload = function () {
            img.classList.remove('card-swatch-fade');
            img.onload = null;
          };
          setTimeout(function () {
            img.classList.remove('card-swatch-fade');
          }, FADE_DURATION);
        }
      }, FADE_DURATION);
    }

    /* Update active swatch */
    var container = swatch.closest('.card-swatches');
    if (container) {
      container.querySelectorAll('.card-swatch').forEach(function (s) {
        s.classList.remove('is-active');
      });
      swatch.classList.add('is-active');
    }

    /* Toggle secondary image hiding for card-product hover effect */
    var cardEl = card.querySelector('.card');
    if (cardEl && container) {
      var isFirst = swatch === container.querySelector('.card-swatch');
      if (isFirst) {
        cardEl.classList.remove('card--swatch-active');
      } else {
        cardEl.classList.add('card--swatch-active');
      }
    }

    /* Update product links to point to selected variant */
    var variantUrl = swatch.getAttribute('href');
    if (variantUrl) {
      card.querySelectorAll('a:not(.card-swatch)').forEach(function (link) {
        if (link.href && link.href.indexOf('/products/') !== -1) {
          link.href = variantUrl;
        }
      });
    }
  });
})();
